import { useState, useMemo } from "react";
import { useCalendarFilter } from "./useCalendarFilter";
import { filterHistoryItemsByCalendar } from "../components/AskVivo/historyUtils";
import type { ChatMessage } from "../components/Chat/chat";

export function useHistoryFilter(items: ChatMessage[]) {
  const [query, setQuery] = useState("");
  const calendarFilter = useCalendarFilter();

  const filtered = useMemo(
    () =>
      filterHistoryItemsByCalendar(items, {
        query,
        appliedDates: calendarFilter.appliedDates,
        appliedValue: calendarFilter.appliedValue,
      }),
    [items, query, calendarFilter.appliedDates, calendarFilter.appliedValue],
  );

  return { query, setQuery, calendarFilter, filtered };
}
